import gql from 'graphql-tag'

export default gql`
  mutation RemoveProductFromCart($input: RemoveProductFromCartInput!) {
    removeProductFromCart(input: $input) {
      ... on Cart {
        id
        cartAmount
        items {
          id
          salesPrice
          sku
          ... on GenericCartItem {
            category
            name
            quantity
            options {
              name
              id
              value
            }
          }
          ... on GiftCardCartItem {
            category
            name
            value
            recipientDetails {
              recipientName
              message
              ... on VirtualRecipientDetails {
                recipientEmail
                senderName
                deliveryDate
                deliveryMethod
              }
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`
